import { AnyAction } from 'redux';

import * as constants from 'redux/constants/proceduresEmails.constants';
import { ITableUpdate } from 'types/table.types';

export const onGetAll = (data: ITableUpdate): AnyAction => ({
  type: constants.PROCEDURES_EMAILS_ON_GET_ALL_REQUESTED,
  ...data,
});

export const onResend = (id: string): AnyAction => ({
  type: constants.PROCEDURES_EMAILS_ON_RESEND_REQUESTED,
  id,
});

export const onSendEmails = (): AnyAction => ({
  type: constants.PROCEDURES_EMAILS_ON_SEND_EMAILS_REQUESTED,
});
